module.exports = __webpack_public_path__ + "img/car-bus.5176a22a.svg";